const nav = document.querySelector('.js-fix-nav')
const fix = nav ? nav.cloneNode(true) : null

const excursion = document.querySelector('.excursion')
const footer = document.querySelector('.footer')
const bottom = excursion ? excursion : footer ? footer : null
if (nav && fix && bottom) {
  fix.classList.add('pageMv__lists--fixNav')
  fix.classList.add('is-hide')
  document.body.appendChild(fix)

  const adjust = () => {
    const scrollTop = window.scrollY
    const scrollBottom = window.scrollY + document.documentElement.clientHeight

    const pointTop =
      nav.getBoundingClientRect().top + nav.clientHeight + window.scrollY + document.documentElement.clientHeight * 0.5
    const pointBottom =
      bottom.getBoundingClientRect().top + window.scrollY - document.documentElement.clientHeight * 0.5

    if (pointTop < scrollTop && scrollBottom < pointBottom) {
      fix.classList.remove('is-hide')
    } else {
      fix.classList.add('is-hide')
    }
  }
  document.addEventListener('scroll', adjust)
  adjust()
}
